<template>
  <div class="stay-pop" id="stay-pop" v-if="popShow">
    <div class="bg" id="bg"></div>
    <div class="card">
      <div class="header">
        <p class="title" v-if="alertInfo.title">{{ alertInfo.title }}</p>
        <img-v3
          :src="require('../../images/icon_close.png')"
          alt=""
          class="pop-close"
          @click="closePop"
        />
      </div>
      <div class="desc">
        {{ alertInfo.desc }}
      </div>
      <div class="btns">
        <p class="btn yes" :class="`${country}`" id="yes-btn" @click="closePop">
          {{ (alertInfo.btn && alertInfo.btn.yes) || $t("确认") }}
        </p>
        <p class="btn no" id="no-btn" @click="closePage">
          {{ (alertInfo.btn && alertInfo.btn.no) || $t("取消") }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["formItem", "idx", "alertInfo"],
  data() {
    return {
      popShow: false,
    };
  },
  computed: {
    country() {
      const params = new URLSearchParams(location.search);
      return params.get("location_country");
    },
    pic_desc() {
      return this.formItem.pic_desc || {};
    },
  },
  mounted() {
    console.log(this.formItem);
  },
  methods: {
    closePop() {
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: 2,
        });
      // fleet安卓的老的重置返回
      Fusion.cancelBackPressedControl && Fusion.cancelBackPressedControl({}, () => {} )
      this.popShow = false;
    },
    closePage() {
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: 2
        });
      Fusion.cancelBackPressedControl && Fusion.cancelBackPressedControl({}, () => {} )
      Fusion.closePage && Fusion.closePage({}, () => {});
      this.popShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.stay-pop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
  /* transform:  translateY(100%); */
  height: 100%;
  width: 100%;
  .bg {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
    opacity: 0.6;
    background: #0f1928;
  }
  .card {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    // padding-bottom: 1.7rem;
    box-sizing: border-box;
    border-radius: 0.36rem 0.36rem 0 0;
    background: #ffffff;
    .header {
      min-height: 1.2rem;
    }
    .pop-close {
      position: absolute;
      right: 0.36rem;
      top: 0.36rem;
      width: 0.48rem;
    }
    .title {
      padding: 0.36rem 0.96rem 0.36rem 0.32rem;
      font-size: 0.4rem;
      font-weight: bold;
      color: #333333;
    }
    .desc {
      padding: 0.05rem 0.33rem 0.33rem 0.33rem;
      font-size: 0.32rem;
      color: #666666;
      letter-spacing: 0;
      line-height: 0.38rem;
      a {
        font-size: 0.32rem;
        font-weight: 500;
        color: #ff7226;
      }
    }
    .btns {
      // position: absolute;
      // bottom: 0;
      width: 100%;
      box-sizing: border-box;
      padding: 0.32rem;
      font-size: 0.36rem;
      color: #ffffff;
      .btn {
          height: 1.08rem;
          line-height: 1.08rem;
          font-weight: 700;
          font-size: 0.4rem;
          text-align: center;
          border-radius: 0.2rem;
      }
      .yes {
        background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
        color: #ffffff;
        &.BR {
          background-image: linear-gradient(-46deg, #FFAE1E 0%, #FFCA00 100%);
          color: #333333;
        }
      }
      .no {
        margin-top: 0.32rem;
        background: #E9ECEE;
        color: #000000;
      }
    }
  }
}
</style>

